import React from 'react'

export default function Location() {
    return (
        <div>
                 <h2>Location Page</h2>
        </div>
    )
}
